export default __webpack_public_path__ + "static/media/vuesax-linear-danger.69167f2e.svg";